import {
  initialState,
  Actions,
  State,
  GET_POST,
  GET_POST_SUCCESS,
  GET_POST_ERROR,
  RESET_GET_POST,
  UPDATE_CURRENT_POST,
} from "../../types/post/get-post";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_POST:
      // Stale-while-revalidate: keep the previous post visible while the new
      // one is fetched. Setting data to null here would cause a brief flash
      // of empty UI on every navigation between related articles. Components
      // that need to react to "loading" should check the `loading` flag
      // instead of falsy-checking `data`. Error path (GET_POST_ERROR) still
      // clears data to null, so genuine missing-post UX is unchanged.
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_POST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_POST_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case UPDATE_CURRENT_POST:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case RESET_GET_POST:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
